import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { ToxnotComponent, ToxnotComponentProperties } from '../../core/BaseApplicationComponents/ToxnotComponent';

interface StepNavigationButtonsLocalProps {
    onPrevious?: () => void;
    onNext?: () => void;
    onSave?: () => void;
    nextDisabled?: boolean;
    previousDisabled?: boolean;
    nextLabel?: string;
    previousLabel?: string;
    saveLabel?: string;
    showPrevious?: boolean;
    showNext?: boolean;
    showSave?: boolean;
    isLoading?: boolean;
}

type StepNavigationButtonsProps = StepNavigationButtonsLocalProps & ToxnotComponentProperties;

class StepNavigationButtonsComponent extends ToxnotComponent<StepNavigationButtonsProps> {
    render() {
        const {
            onPrevious,
            onNext,
            onSave,
            nextDisabled = false,
            previousDisabled = false,
            nextLabel,
            previousLabel,
            saveLabel,
            showPrevious = true,
            showNext = true,
            showSave = false,
            isLoading = false
        } = this.props;

        return (
            <div className="text-right" style={{ marginTop: '15px' }}>
                {showPrevious && onPrevious && (
                    <button 
                        className="btn btn-default" 
                        disabled={previousDisabled || isLoading} 
                        onClick={onPrevious}
                    >
                        {previousLabel || this.localizeString("Back")}
                    </button>
                )}
                {showNext && onNext && (
                    <button 
                        className="btn btn-toxnot-primary" 
                        style={{ marginLeft: "10px" }} 
                        onClick={onNext}
                        disabled={nextDisabled || isLoading}
                    >
                        {nextLabel || this.localizeString("Next")}
                    </button>
                )}
                {showSave && onSave && (
                    <button 
                        className="btn btn-toxnot-primary" 
                        style={{ marginLeft: "10px" }} 
                        onClick={onSave}
                        disabled={nextDisabled || isLoading}
                    >
                        {saveLabel || this.localizeString("Save Configuration")}
                    </button>
                )}
            </div>
        );
    }
}

export const StepNavigationButtons = connect(
    (state: ApplicationState) => ({ appServices: state.appServices! })
)(StepNavigationButtonsComponent);
